import { KpkMedia } from "@keepeek/commons";

import { Type } from "../../../models/configuration/definitions/widget";
import { WidgetConfigurations } from "../models";

function needElementIdInConfiguration(widgetKeyConfig: string): boolean {
  return (
    widgetKeyConfig.startsWith(`${Type.Sheet} - `) ||
    widgetKeyConfig.startsWith(`${Type.Tabs} - `) ||
    widgetKeyConfig.startsWith(`${Type.Attachments} - `)
  );
}

export function injectElementIdInConfigurationIfNeeded({
  elementId,
  widgetsConfiguration,
}: {
  elementId?: KpkMedia["id"];
  widgetsConfiguration?: WidgetConfigurations;
}): WidgetConfigurations | undefined {
  if (!widgetsConfiguration) {
    return undefined;
  }
  if (!elementId) {
    return widgetsConfiguration;
  }
  const ret: WidgetConfigurations = { ...widgetsConfiguration };
  for (const widgetKeyConfig of Object.keys(ret)) {
    if (needElementIdInConfiguration(widgetKeyConfig)) {
      ret[widgetKeyConfig] = {
        ...ret[widgetKeyConfig],
        elementId,
      };
    }
  }
  return ret;
}
